import { api } from './client';

/**
 * Карточка куратора в админке (28.09.2026) — договор `docs/CONTRACTS/curator-card.md`.
 *
 * Сервер — progress-service, admin и manager. Путь под `/admin/analytics/curators/…`: этот префикс шлюз уже ведёт в
 * progress; `/admin/curators/…` не ведёт никуда. Пути — буквальные: сторож `adminRoutesInGateway.test.ts` читает их
 * из кода.
 *
 * ⚠️ УЧЕНИКИ — ПО ТОМУ ЖЕ ПРАВИЛУ, ЧТО ОЧЕРЕДЬ ДОМАШЕК КУРАТОРА: активные записи, личные и через его группы.
 */

export type CuratorCardEnrollment = {
  enrollment_id: string;
  marathon_id: string;
  marathon_title: string;
  group_id: string | null;
  group_name: string | null;
  /** group — ученик у куратора через его группу; personal — через поле куратора записи (запись без группы). */
  via: 'group' | 'personal';
  access_until: string | null;
};

export type CuratorCardStudent = {
  student_id: string;
  full_name: string;
  /** Для поиска в карточке (28.09.2026); старый сервер поля не шлёт. */
  email?: string;
  avatar_url: string;
  last_seen_at: string | null;
  /** Работ на проверке у ученика — по набору учеников куратора, а не по полю «кто проверял». */
  pending: number;
  enrollments: CuratorCardEnrollment[];
};

export type CuratorCardSummary = {
  students: number;
  pending_submissions: number;
  pending_students: number;
  reviewed_30d: number;
  /** Средний срок «сдал → проверено» за 30 дней, часы; null — проверок за окно не было. */
  avg_response_hours_30d: number | null;
};

export type CuratorCardOverview = {
  curator_id: string;
  summary: CuratorCardSummary;
  students: CuratorCardStudent[];
};

export type CuratorReviewItem = {
  kind: 'lesson_grade' | 'homework';
  at: string;
  student_id: string;
  student_name: string;
  lesson_id: string | null;
  lesson_title: string | null;
  marathon_title: string | null;
  /** Оценка урока; у lesson_grade null — «оценку сняли», у домашки всегда null. */
  grade: number | null;
  feedback: string | null;
  /** Решение по домашке: approved | revision | rejected; у оценки урока null. */
  status: string | null;
  credited_without_answers: boolean;
};

export type CuratorReviewsPage = { items: CuratorReviewItem[]; next_before: string | null };

export const curatorCardApi = {
  async overview(curatorId: string) {
    const { data } = await api.get(`/admin/analytics/curators/${curatorId}/overview`);
    return data as CuratorCardOverview;
  },
  /** `q` — поиск по ученику (имя, почта) и уроку по всей ленте, на сервере (28.09.2026). */
  async reviews(curatorId: string, before?: string | null, q?: string) {
    const { data } = await api.get(`/admin/analytics/curators/${curatorId}/reviews`, {
      params: { limit: 50, ...(before ? { before } : {}), ...(q ? { q } : {}) },
    });
    const page = data as CuratorReviewsPage;
    return { items: page.items ?? [], next_before: page.next_before ?? null };
  },
};
